export default {
  getAll: {
    url: '/api/attendance/getAll',
    method: 'get'
  },
  create: {
    url: '/api/attendance/create',
    method: 'post'
  },
  update: {
    url: '/api/attendance/update',
    method: 'put'
  },
  delete: {
    url: '/api/attendance/delete',
    method: 'delete'
  },
  analysis: {
    url: '/api/attendance/analysis',
    method: 'get'
  }
}



// WEBPACK FOOTER //
// ./src/api/attendance.js